import {
    numberZoneList, apnZoneList, operatorZoneList, icZoneList,
    createNumberZone, submitNumberZone,
    editNumberZone, updateNumberZone,
    dataByIdNumberZone, deleteNumberElement,
    submitApnZone, editApnZone, updateApnZone,
    dataByIdApnZone, deleteApnElement,
    submitOperatorZone, editOperatorZone,
    updateOperatorZone, dataByIdOparetorZone,
    deleteOperatorElement, submitIcZone,
    updateIcZone, dataByIcZone, deleteIcElement
} from "@/http/setup/zoneSetup";


export default {
    namespaced: true,
    state: {

        GetNumberZone: [],
        GetApnZone: [],
        GetOperatorZone: [],
        GetIcZone: [],
        numberZoneTemplate: {},
        numberZoneId: {}
    },
    actions: {

        async setNumberZoneList({ commit }) {
            const resp = await numberZoneList();
            commit('SET_NUMBER_ZONE_LIST', resp.data.pageItems);
            return resp;
        },
        async setApnZoneList({ commit }) {
            const resp = await apnZoneList();
            commit('SET_APN_ZONE_LIST', resp.data.pageItems);
            return resp;
        },
        async setOperatorZoneList({ commit }) {
            const resp = await operatorZoneList();
            commit('SET_OPERATOR_ZONE_LIST', resp.data.pageItems);
            return resp;
        },
        async setIcZoneList({ commit }) {
            const resp = await icZoneList();
            commit('SET_IC_ZONE_LIST', resp.data.pageItems);
            return resp;
        },
        async deleteNumZone({ commit }, id) {
            const resp = await deleteNumberElement(id);
            return resp;
        },
        async deleteApnZone({ commit }, id) {
            const resp = await deleteApnElement(id);
            return resp;
        },
        async deleteOperatorZone({ commit }, id) {
            const resp = await deleteOperatorElement(id);
            return resp;
        },
        async deleteIcZone({ commit }, id) {
            const resp = await deleteIcElement(id);
            (id);
            return resp;
        },
        async fetchNumberZoneTemplate({ commit }) {
            const resp = await createNumberZone();
            commit('SET_NUMBER_ZONE_TEMPLATE', resp.data);
            return resp;
        },
        async submitIcZoneAction({ commit }, payload) {
            const resp = await submitIcZone(payload);
            return resp;
        },
        async fetchNumberZoneIdAction({ commit }, id) {
            const resp = await editNumberZone(id);
            commit('SET_NUMBER_ZONE_ID', resp.data);
            return resp;
        },
        async updateIcZoneAction({ commit }, payload) {
            const resp = await updateIcZone(payload.id, payload.data);
            return resp;
        },
        async submitOperatorZoneAction({ commit }, payload) {
            const resp = await submitOperatorZone(payload);
            return resp;
        },
        async fetchOperatorZoneIdAction({ commit }, id) {
            const resp = await editOperatorZone(id);
            commit('SET_NUMBER_ZONE_ID', resp.data);
            return resp;
        },
        async submitApnZoneAction({ commit }, payload) {
            const resp = await submitApnZone(payload);
            return resp;
        },
        async fetchApnZoneIdAction({ commit }, id) {
            const resp = await editApnZone(id);
            commit('SET_NUMBER_ZONE_ID', resp.data);
            return resp;
        },
        async updateOperatorZoneAction({ commit }, payload) {
            const resp = await updateOperatorZone(payload.id, payload.data);
            return resp;
        },
        async updateApnZoneAction({ commit }, payload) {
            const resp = await updateApnZone(payload.id, payload.data);
            return resp;
        },
        async submitNumberZoneAction({ commit }, payload) {
            const resp = await submitNumberZone(payload);
            return resp;
        },
        async updateNumberZoneAction({ commit }, payload) {
            const resp = await updateNumberZone(payload.id, payload.data);
            return resp;
        },
        async fetchIcZoneDataAction({ commit }, id) {
            const resp = await dataByIcZone(id);
            commit('SET_NUMBER_ZONE_ID', resp.data);
            return resp;
        },
    },
    mutations: {

        ['SET_NUMBER_ZONE_LIST'](state, payload) {
            Object.assign(state, { GetNumberZone: payload });
        },
        ['SET_APN_ZONE_LIST'](state, payload) {
            Object.assign(state, { GetApnZone: payload });
        },
        ['SET_OPERATOR_ZONE_LIST'](state, payload) {
            Object.assign(state, { GetOperatorZone: payload });
        },
        ['SET_IC_ZONE_LIST'](state, payload) {
            Object.assign(state, { GetIcZone: payload });
        },
        ['SET_NUMBER_ZONE_TEMPLATE'](state, payload) {
            Object.assign(state, { numberZoneTemplate: payload });
        },
        ['SET_NUMBER_ZONE_ID'](state, payload) {
            Object.assign(state, { numberZoneId: payload });
        },

    }
}